module.exports = __webpack_public_path__ + "img/product-shot_05.5f9a04bc.jpg";